import ReferenceControleFormController from './reference.controle.form.controller';

export default {
    template: require('./reference.controle.form.html'),
    controller: ReferenceControleFormController
};
